import { Card } from "@mui/material";
import Grid from "@mui/material/Grid2";
import { useFormikContext } from "formik";
import React from "react";
import { useNavigate } from "react-router-dom";

import FormField from "@/components/atoms/FormField";
import MDBox from "@/components/atoms/MDBox";
import { MDButton } from "@/components/atoms/MDButton";
import MDTypography from "@/components/atoms/MDTypography";
import ROUTE_URLS from "@/constants/route-urls";
import useLanguage from "@/contexts/language-context";
import { VariationFormMessages } from "@/messages/variation/variations-form.messages";

import { VariationFormData } from "./types";

type Props = {
  messages: VariationFormMessages;
  isLoading: boolean;
};

export default function VariationForm({ messages, isLoading }: Props) {
  const { values, handleChange, submitForm, errors } = useFormikContext<VariationFormData>();
  const router = useNavigate();
  const { lang } = useLanguage();

  return (
    <MDBox>
      <Grid container spacing={3}>
        <Grid size={{ xs: 12, lg: 12 }}>
          <Card>
            <MDBox p={3}>
              <MDBox display="flex" justifyContent="space-between">
                <MDTypography variant="h5" fontWeight={"bold"}>
                  {values.isEditing ? "Editar Variação  " : "Nova Variação"}
                </MDTypography>
              </MDBox>

              <MDBox mt={1}>
                <Grid container spacing={3}>
                  <Grid size={{ xs: 12, sm: 4 }}>
                    <FormField
                      externalLabel
                      variant="standard"
                      name="description"
                      label={messages.descriptionLabel}
                      value={values.description}
                      onChange={handleChange}
                      fullWidth
                      multiline
                      error={!!errors.description}
                    />
                  </Grid>
                </Grid>
              </MDBox>
            </MDBox>
          </Card>
        </Grid>
      </Grid>

      <MDBox mt={2}>
        <Grid container spacing={3} alignItems="center">
          <Grid size={12}>
            <MDBox display="flex" justifyContent="flex-end" gap={2}>
              <MDButton
                variant="gradient"
                color="light"
                onClick={() => router(ROUTE_URLS.variations(lang))}
                isLoading={isLoading}
              >
                {messages.cancelButton}
              </MDButton>

              <MDButton variant="gradient" color="dark" onClick={submitForm} isLoading={isLoading}>
                {messages.updateButton}
              </MDButton>
            </MDBox>
          </Grid>
        </Grid>
      </MDBox>
    </MDBox>
  );
}
